import { takeLatest } from 'redux-saga/effects';
import {
    GET_INSTITUTES_REQUEST,
    GET_CLASSIFICATIONTYPES_REQUEST,
    GET_FEDERALSTATES_REQUEST,
    GET_SCHOOLYEARS_REQUEST,
    GET_USAGETYPES_REQUEST,
    UPDATE_SCHOOLYEAR_REQUEST,
    GET_NEXTSCHOOLYEAR_REQUEST,
    GET_ACTUALSCHOOLYEAR_REQUEST,
    GET_PREVIOUSSCHOOLYEAR_REQUEST,
} from '../constants/jointPowersActionTypes'
import {
    getInstitutesSuccess,
    getInstitutesFailure,
    getSchoolYearsSuccess,
    getSchoolYearsFailure,
    getFederalStatesSuccess,
    getFederalStatesFailure,
    getClassificationTypesSuccess,
    getClassificationTypesFailure,
    getUsageTypesSuccess,
    getUsageTypesFailure,
    updateSchoolYearSuccess,
    updateSchoolYearFailure,
    getNextSchoolYearSuccess,
    getNextSchoolYearFailure,
    getActualSchoolYearFailure,
    getActualSchoolYearSuccess,
    getPreviousSchoolYearSuccess,
    getPreviousSchoolYearFailure,
} from "../actions/jointPowersActions";
import { handleApiRequest } from '../utils/sagaUtils';
import {apiCall} from "../utils/api";

const getInstitutes = () => apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/getInstitutes`, 'GET');
const getSchoolYears = () => apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/getSchoolYears`, 'GET');
const getNextSchoolYear = () => apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/getNextSchoolYear`, 'GET');
const getActualSchoolYear = () => apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/getActualSchoolYear`, 'GET');
const getPreviousSchoolYear = () => apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/getPreviousSchoolYear`, 'GET');
const getFederalStates = () => apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/getFederalStates`, 'GET');
const getClassificationTypes = () => apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/getClassificationTypes`, 'GET');
const getUsageTypes = () => apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/getUsageTypes`, 'GET');
const updateSchoolYear = (data) => apiCall(`${process.env.REACT_APP_API_URL}/jointpower-api/updateSchoolYear`, 'POST', data);

function* getInstitutesSaga(action) {
    yield* handleApiRequest(action, getInstitutes, getInstitutesSuccess, getInstitutesFailure);
}

function* getSchoolYearsSaga(action) {
    yield* handleApiRequest(action, getSchoolYears, getSchoolYearsSuccess, getSchoolYearsFailure);
}

function* getNextSchoolYearSaga(action) {
    yield* handleApiRequest(action, getNextSchoolYear, getNextSchoolYearSuccess, getNextSchoolYearFailure);
}

function* getActualSchoolYearSaga(action) {
    yield* handleApiRequest(action, getActualSchoolYear, getActualSchoolYearSuccess, getActualSchoolYearFailure);
}

function* getPreviousSchoolYearSaga(action) {
    yield* handleApiRequest(action, getPreviousSchoolYear, getPreviousSchoolYearSuccess, getPreviousSchoolYearFailure);
}

function* getFederalStatesSaga(action) {
    yield* handleApiRequest(action, getFederalStates, getFederalStatesSuccess, getFederalStatesFailure);
}

function* getClassificationTypesSaga(action) {
    yield* handleApiRequest(action, getClassificationTypes, getClassificationTypesSuccess, getClassificationTypesFailure);
}

function* getUsageTypesSaga(action) {
    yield* handleApiRequest(action, getUsageTypes, getUsageTypesSuccess, getUsageTypesFailure);
}

function* updateSchoolYearSaga(action) {
    yield* handleApiRequest(action, updateSchoolYear, updateSchoolYearSuccess, updateSchoolYearFailure);
}

export default function* watchJointPowersSagas() {
    yield takeLatest(GET_INSTITUTES_REQUEST, getInstitutesSaga);
    yield takeLatest(GET_SCHOOLYEARS_REQUEST, getSchoolYearsSaga);
    yield takeLatest(GET_FEDERALSTATES_REQUEST, getFederalStatesSaga);
    yield takeLatest(GET_CLASSIFICATIONTYPES_REQUEST, getClassificationTypesSaga);
    yield takeLatest(GET_USAGETYPES_REQUEST, getUsageTypesSaga);
    yield takeLatest(UPDATE_SCHOOLYEAR_REQUEST, updateSchoolYearSaga);
    yield takeLatest(GET_NEXTSCHOOLYEAR_REQUEST, getNextSchoolYearSaga);
    yield takeLatest(GET_ACTUALSCHOOLYEAR_REQUEST, getActualSchoolYearSaga);
    yield takeLatest(GET_PREVIOUSSCHOOLYEAR_REQUEST, getPreviousSchoolYearSaga);
}